module.exports = __webpack_public_path__ + "img/basket.a97347ec.svg";